export const formatCurrency = (price: number) => {
	return price.toLocaleString('th-TH', {
		style: 'currency',
		currency: 'THB'
	});
};
